import { Component, OnInit } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import {
  Parameters,
  PledgeRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
    selector: 'compte-titre-amount',
    templateUrl: './compte-titre-amount.component.html',
    styleUrls: ['./compte-titre-amount.component.scss'],
    standalone: false
})
export class CompteTitreAmountComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  feilds = {
    investmentAmount: 'investmentAmount',
    taxReductionAmount: 'taxReductionAmount',
  };
  error: ValidationErrors = null;
  sessionConsultant: boolean = false;
  pledge: PledgeRead;
  parameters: Parameters;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.pledge = this.subscriptionFacade.getPledge();
    this.parameters = this.pledge?.parameters;
    this.sessionConsultant =
      !!this.pledge && !!this.subscriptionFacade?.getUser()?.sessionConsultant;
    this.subscriptionFacade.initForm(this, {
      sessionConsultant: this.sessionConsultant,
    });

    this.formValueChanges();
  }
  formValueChanges() {
    this.subscriptionFacade
      .setupFormValueAmountChanges(
        this.form,
        this.feilds,
        this.sessionConsultant,
      )
      .pipe(untilDestroyed(this))
      .subscribe(error => {
        this.error = error;
      });
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
